import { createApiCallSelectors } from '../../../common/store/generic.selectors';
import { createFeatureSelector } from '@ngrx/store';
import { ISourceState } from './source.reducer';
import { sourceFeatureKey, SourceModel } from './types';

const sourceFeatureState =
  createFeatureSelector<ISourceState>(sourceFeatureKey);

export const sourceSelectors = {
  getById: createApiCallSelectors<number, ISourceState>(
    sourceFeatureState,
    'getById',
  ),
  getList: createApiCallSelectors<void, ISourceState>(
    sourceFeatureState,
    'getList',
  ),
  add: createApiCallSelectors<SourceModel, ISourceState>(
    sourceFeatureState,
    'add',
  ),
  update: createApiCallSelectors<SourceModel, ISourceState>(
    sourceFeatureState,
    'update',
  ),
};
